import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';

// Define los estilos con el tipo CSSProperties
export const styles = makeStyles(() => ({
	inputContainer: {
		position: "relative",
		display: "inline-block",
		width: "100%",
		borderRadius: "4px"
	},
	input: {
		width: "100%",
		padding: "10px",
		paddingRight: "35px",  // Espacio para el icono
		boxSizing: "border-box",
		borderRadius: "4px",
		borderColor: "rgba(0, 0, 0, 0.8)",
		marginTop: 8,
		"&:hover": {
			borderColor: "black"
		}
	},
	calendarIcon: {
		position: "absolute",
		right: "10px",
		top: "50%",
		transform: "translateY(-50%)",
		cursor: "pointer",
		width: "20px",
		height: "20px",
		fill: "#888", // Color del icono
	},
	calendar: {
		position: "absolute",
		border: "1px solid #ccc",
		padding: "10px",
		borderRadius: "4px",
		backgroundColor: "white",
		zIndex: 1,
	},
	header: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: "10px",
	},
	headerbutton: {
		border: "none",
		background: "white",
		fontSize: "18px",
		"&:hover": {
			background: "#969493"
		}
	},
	daysContainer: {
		display: "grid",
		gridTemplateColumns: "repeat(7, 1fr)",
		gap: "5px",
	},
	day: {
		padding: "10px",
		cursor: "pointer",
		borderRadius: "15px"
	},
}));

// Función de ayuda para obtener una lista de días en un mes determinado
const getDaysInMonth = (month: number, year: number) => {
	return new Array(31).fill(null).map((_, index) => {
		const date = new Date(year, month, index + 1);
		return date.getMonth() === month ? date : null;
	}).filter(date => date);
};

const DatePickerRange = (props: {
	range: { startDate: Date, endDate: Date } | null;
	handleDateRange: (data: { startDate: Date ; endDate: Date | null}) => void
}) => {
	const {range , handleDateRange} = props;
	const currentStyled = styles();
	const [isOpen, setIsOpen] = useState(false);
	const [startDate, setStartDate] = useState<Date | null>(null);
	const [endDate, setEndDate] = useState<Date | null>(null);
	const [isSelectingEndDate, setIsSelectingEndDate] = useState(false);
	const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
	const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

	const daysInMonth = getDaysInMonth(currentMonth, currentYear);

	// Maneja el cambio de mes
	const handlePreviousMonth = () => {
		if (currentMonth === 0) {
			setCurrentMonth(11);
			setCurrentYear(currentYear - 1);
		} else {
			setCurrentMonth(currentMonth - 1);
		}
	};

	const handleNextMonth = () => {
		if (currentMonth === 11) {
			setCurrentMonth(0);
			setCurrentYear(currentYear + 1);
		} else {
			setCurrentMonth(currentMonth + 1);
		}
	};

	// Maneja la selección de fechas
	const handleDateSelect = (date: Date) => {
		if (!isSelectingEndDate) {
			setStartDate(date);
			setEndDate(null);
			setIsSelectingEndDate(true);
		} else {
			if (startDate) {
				const endDate = date >= startDate ? date : null;
				setEndDate(endDate);
				setIsSelectingEndDate(false);
				setIsOpen(false);
				handleDateRange({ startDate: startDate, endDate: endDate });
			}
		}
	};

	useEffect(() => {
		if (!range) {setStartDate(null); setEndDate(null); return;}
		setStartDate(range.startDate);
		setEndDate(range.endDate);
	}, [range]);
	return (
		<div>
			<div className={currentStyled.inputContainer}>
				<input
					type="text"
					className={currentStyled.input}
					value={
						startDate && endDate
							? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
							: "MM/DD/AAAA"
					}
					onClick={() => setIsOpen(!isOpen)}
					readOnly
				/>
				<svg
					onClick={() => setIsOpen(!isOpen)}
					className={currentStyled.calendarIcon}
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
				>
					<path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H5V9h14v12zm-7-4h5v-5h-5v5zm-7 2h5v-5H5v5zm0-7h5v-5H5v5zm7 0h5v-5h-5v5zm7 0h5v-5h-5v5z" />
				</svg>
			</div>
			{isOpen && (
				<div className={currentStyled.calendar}>
					<div className={currentStyled.header}>
						<button className={currentStyled.headerbutton} onClick={handlePreviousMonth}>{"<"}</button>
						<span>{`${new Date(currentYear, currentMonth).toLocaleString('default', { month: 'long' })} ${currentYear}`}</span>
						<button className={currentStyled.headerbutton} onClick={handleNextMonth}>{">"}</button>
					</div>
					<div className={currentStyled.daysContainer}>
						{daysInMonth.map((day, index) => (
							day && (
								<button
									key={index}
									className={currentStyled.day}
									style={{
										backgroundColor:
											(startDate && day >= startDate && (!endDate || day <= endDate)) ? "#D3E4FF" : "transparent",
										color: day?.toDateString() === (startDate ? startDate.toDateString() : "")
											? "blue"
											: day?.toDateString() === (endDate ? endDate.toDateString() : "")
												? "red"
												: "black",
									}}
									onClick={() => handleDateSelect(day)}
								>
									{day?.getDate()}
								</button>)
						))}
					</div>
				</div>
			)}
		</div>
	);
};
export default DatePickerRange;
